export default function Done({ color, size: number = 20 }) {
  return (
    <svg width={number} height={number} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.50006 13.5L4.58339 10.5833C4.25839 10.2583 3.74172 10.2583 3.41672 10.5833C3.09172 10.9083 3.09172 11.425 3.41672 11.75L6.90839 15.2417C7.23339 15.5667 7.75839 15.5667 8.08339 15.2417L16.9167 6.41667C17.2417 6.09167 17.2417 5.57501 16.9167 5.25001C16.5917 4.92501 16.0751 4.92501 15.7501 5.25001L7.50006 13.5Z'
        fill={color}
      />
    </svg>
  );
}
